module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "d12e582"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Dekk_ISBN141856625X_epub_c7.1_r1#d12e464",
      "id": "d12e583"
    }
  }, [_vm._v("beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e585"
    }
  }, [_c('b', [_vm._v("O")]), _vm._v("ur story begins in a world totally like our own, yet completely different. What once happened here in our own history seems to be repeating itself, thousands of years from now, some time beyond the year AD 4000.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e589"
    }
  }, [_vm._v("But this time the future belongs to the young, to the warriors, to the lovers. To those who can follow hidden clues and find a great treasure, which will unlock the mysteries of life and wealth. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e591"
    }
  }, [_vm._v("Thirteen years have passed since the lush, colored forests were turned to desert by Teeleh, the enemy of Elyon and the vilest of all creatures. Evil now rules the land and shows itself as a painful, scaly disease that covers the flesh of the Horde, who live in the desert.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e593"
    }
  }, [_vm._v("The powerful green waters, once precious to Elyon, have vanished from the earth except in seven small forests surrounding seven small lakes. Those few who have chosen to follow the ways of Elyon are now called Forest Dwellers, and they bathe once daily in the powerful waters to cleanse their skin of the disease.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e595"
    }
  }, [_vm._v("The number of their sworn enemy, the Horde, has grown, and the Forest Guard has been severely diminished by war, forcing Thomas, supreme commander, to lower the army’s recruitment age to sixteen. One thousand young recruits have shown themselves worthy and now serve in the Forest Guard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e597"
    }
  }, [_vm._v("From among the thousand, four young fighters—Johnis, Silvie, Billos, and Darsal—were handpicked by Thomas to lead. Sent into the desert, they faced terrible danger and returned celebrated heroes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e599"
    }
  }, [_vm._v("Unbeknownst to Thomas and the Forest Dwellers, our heroes have also been chosen by the legendary white Roush, guardians of all that is good, for a greater mission, and they are forbidden to tell a soul.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e601"
    }
  }, [_vm._v("Their quest is to find the seven original Books of History, which together hold the power to destroy humankind. They were given the one book in the Roush’s possession and have recovered two more. They must now find the other four books before the Dark One finds them and unleashes their power to enslave humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e603"
    }
  }, [_vm._v("Although the full extent of the power contained in these sealed books is unknown, the four have discovered that touching them with blood creates a breach into what appears to be another reality. A breach they have been warned not to cross.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e605"
    }
  }, [_vm._v("But Billos is not the kind to heed warnings. And his lust for the power contained in the books has overtaken all good sense.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357a8ac9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dekk_ISBN141856625X_epub_c8_r1.vue
// module id = 78
// module chunks = 0